module.exports = {
  publicPath: process.env.NODE_ENV === "production" ? "/" : "/dev",
  devServer: {
    port: 3000
  }
};
